// Buckets mirror ExpiringPaymentMethodsCriteria::ALL_BUCKETS on the backend.
// Keep this list in lockstep when adding/renaming buckets server-side.
export const EXPIRY_BUCKETS = [
  "EXPIRED",
  "LT_30",
  "M30_60",
  "M60_90",
  "GT_90",
] as const;

export type ExpiryBucket = (typeof EXPIRY_BUCKETS)[number];

export const EXPIRY_BUCKET_LABEL: Record<ExpiryBucket, string> = {
  EXPIRED: "Ya caducadas",
  LT_30: "≤ 30 días",
  M30_60: "30-60 días",
  M60_90: "60-90 días",
  GT_90: "> 90 días",
};

export const EXPIRY_BUCKET_STYLES: Record<
  ExpiryBucket,
  { bg: string; fg: string }
> = {
  EXPIRED: { bg: "#7c1d1d", fg: "white" },
  LT_30: { bg: "#fde2e2", fg: "#b32424" },
  M30_60: { bg: "#fff3cd", fg: "#856404" },
  M60_90: { bg: "#e3f2fd", fg: "#0d47a1" },
  GT_90: { bg: "#d4edda", fg: "#155724" },
};

export type ExpiringPaymentMethodRow = {
  subscriptionUuid: string;
  paymentMethodId: string;
  stripeCustomerId: string | null;
  leadId: number | null;
  leadUlid: string | null;
  leadEmail: string | null;
  leadName: string | null;
  leadMarket: string | null;
  leadStatus: string | null;
  policyNumber: string | null;
  carrier: string | null;
  type: string | null;
  lastNumbers: string | null;
  expiresRaw: string;
  expiresAt: string;
  daysToExpire: number;
  bucket: ExpiryBucket | string;
};

export type ExpiringPaymentMethodsResponse = {
  rows: ExpiringPaymentMethodRow[];
  total: number;
  limit: number;
  offset: number;
  aggregates: {
    countsByBucket: Partial<Record<ExpiryBucket, number>>;
  };
};
